import { render } from "./ProjectIcon.vue?vue&type=template&id=f4c80dd2&scoped=true"
import script from "./ProjectIcon.vue?vue&type=script&lang=js"
export * from "./ProjectIcon.vue?vue&type=script&lang=js"

import "./ProjectIcon.vue?vue&type=style&index=0&id=f4c80dd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c80dd2"]])

export default __exports__